export default __webpack_public_path__ + "static/Fachada-9671f57f671c543bad22af06189825b0.jpg";